<template>
    <div id="app">
        <router-view />
        <FixedEl v-if="showFixedEl" />
    </div>
</template>

<script>
import FixedEl from '@/components/FixedEl.vue'

export default {
    name: 'App',
    components: {
        FixedEl
    },
    computed: {
        showFixedEl() {
            return this.$route.name && this.$route.name.indexOf('Part') > -1
        }
    }
}
</script>

<style lang="less">
@import './assets/style/reset';
#app {
    font-size: 16px;
    width: 100%;
    min-height: 100vh;
    background-color: #121212;
}
</style>
